<template>
  <BaseCard>
    <BaseCardBody>
      <div>
        <h3 class="text-lg">Pipeline Cover</h3>
        <p class="text-sm text-gray-600">Change your pipeline's cover image</p>
      </div>
      <div class="space-y-4 lg:space-y-6 mt-6">
        <div class="relative max-w-lg bg-gray-200 rounded overflow-hidden">
          <FilePond
            name="file"
            ref="pond"
            :label-idle="labelIdle"
            image-resize-target-width="1024"
            style-panel-layout="compact integrated"
            style-panel-aspect-ratio="5:4"
            style-load-indicator-position="center bottom"
            style-progress-indicator-position="right bottom"
            style-button-remove-item-position="left bottom"
            style-button-process-item-position="right bottom"
            :allow-revert="false"
            accept="image/png, image/jpeg, image/gif"
            :server="serverOptions"
            :onprocessfile="onProcessFile"
          />
        </div>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import { getCookie } from '@/utils/helpers';

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginFilePoster
);

export default {
  name: 'CoverForm',

  components: {
    FilePond,
  },

  props: {
    pipeline: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      serverOptions: {
        process: {
          url: `/api/v1/pipelines/${this.pipeline.id}/cover`,
          method: 'POST',
          withCredentials: true,
          timeout: 7000,
          onerror: null,
          headers: {
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
          onload: (response) => {
            const { data = null } = JSON.parse(response);
            this.onUploaded(data);
          },
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },

  computed: {
    labelIdle() {
      if (this.pipeline.cover) {
        return `<img src='${this.pipeline.cover}' class='absolute inset-0 w-full h-full object-cover'>`;
      }

      return 'Drag & Drop your picture or <span class="filepond--label-action">Browse</span>';
    },
  },

  methods: {
    async onUploaded(data) {
      if (!data) {
        return;
      }

      this.$emit('changed');
    },
    onProcessFile(error, file) {
      setTimeout(() => {
        if (file.status === 5) {
          this.$refs.pond.removeFile(file.id);
        }
      }, 1500);
    },
  },
};
</script>
